export default __webpack_public_path__ + "static/logoSofteco-9b26e26812b7374dcea289aff1c46113.png";